/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:48:06
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 11:07:55
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'HelpFaqItem',

  props: ['item', 'index'],

  data() {
    return {
      isCollapsed: true,
    };
  },

};



// WEBPACK FOOTER //
// ./src/components/Help/HelpFaq/HelpFaqItem/component.js